import { render, staticRenderFns } from "./xh-footer.vue?vue&type=template&id=09fb054e&scoped=true&"
import script from "./xh-footer.vue?vue&type=script&lang=js&"
export * from "./xh-footer.vue?vue&type=script&lang=js&"
import style0 from "./xh-footer.vue?vue&type=style&index=0&id=09fb054e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fb054e",
  null
  
)

export default component.exports